// Hover flyout for left-menu items that hold sections (Engage: Feed, Polls...).
// The menu column scrolls and clips an in-flow panel, so the panel is moved
// to document.body and placed beside its item. Leave is decided from whether
// the pointer is actually over the item or the panel - mouseout alone misses
// the window chrome, the OS dock, and some overflow hit-testing gaps, which
// is what left the box hanging after the cursor had already gone.
(function () {
  var open = null;
  var hideTimer = null;

  function clearHide() {
    if (!hideTimer) return;
    clearTimeout(hideTimer);
    hideTimer = null;
  }

  function flyOf(group) {
    return (group && group._csFly) || (group && group.querySelector && group.querySelector(".cs-nav-fly"));
  }

  function groupFrom(node) {
    if (!node) return null;
    if (node.nodeType !== 1) node = node.parentElement;
    if (!node || !node.closest) return null;
    var fly = node.closest(".cs-nav-fly");
    if (fly && fly._csGroup) return fly._csGroup;
    var group = node.closest(".cs-nav-group");
    if (group && flyOf(group)) return group;
    return null;
  }

  function overPair(group, node) {
    if (!group || !node) return false;
    if (group.contains(node)) return true;
    var fly = flyOf(group);
    return !!(fly && fly.contains(node));
  }

  function place(group) {
    var fly = flyOf(group);
    var item = group.querySelector(".cs-nav-item");
    if (!fly || !item) return;
    var r = item.getBoundingClientRect();
    fly.style.left = Math.round(r.right) + "px";
    var top = r.top;
    var h = fly.offsetHeight || 0;
    if (top + h > window.innerHeight - 8) top = Math.max(8, window.innerHeight - h - 8);
    fly.style.top = Math.round(top) + "px";
  }

  function hide(group) {
    clearHide();
    if (!group) return;
    group.classList.remove("cs-fly-open");
    var fly = flyOf(group);
    if (fly) {
      fly.classList.remove("cs-fly-open");
      fly.style.left = "";
      fly.style.top = "";
      if (group.isConnected) group.appendChild(fly);
      else fly.remove();
    }
    if (open === group) open = null;
  }

  function show(group) {
    var fly = group && group.querySelector(".cs-nav-fly");
    if (!fly) fly = flyOf(group);
    if (!group || !fly) return;
    clearHide();
    if (open && open !== group) hide(open);
    if (fly.parentNode !== document.body) document.body.appendChild(fly);
    group._csFly = fly;
    fly._csGroup = group;
    open = group;
    group.classList.add("cs-fly-open");
    fly.classList.add("cs-fly-open");
    place(group);
  }

  function hideSoon(group) {
    if (!group || hideTimer) return;
    hideTimer = setTimeout(function () {
      hideTimer = null;
      if (open !== group) return;
      if (group.matches && group.matches(":hover")) return;
      var fly = flyOf(group);
      if (fly && fly.matches && fly.matches(":hover")) return;
      hide(group);
    }, 80);
  }

  document.addEventListener("pointerover", function (e) {
    var group = groupFrom(e.target);
    if (group) show(group);
  });

  document.addEventListener("pointerout", function (e) {
    var group = groupFrom(e.target) || open;
    if (!group) return;
    if (overPair(group, e.relatedTarget)) return;
    hideSoon(group);
  });

  document.addEventListener(
    "pointermove",
    function (e) {
      if (!open) return;
      if (overPair(open, e.target)) {
        clearHide();
        return;
      }
      hideSoon(open);
    },
    { passive: true }
  );

  document.documentElement.addEventListener("mouseleave", function () {
    if (open) hide(open);
  });
  window.addEventListener("blur", function () {
    if (open) hide(open);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && open) hide(open);
  });
  document.addEventListener(
    "scroll",
    function () {
      if (open) hide(open);
    },
    true
  );
  document.addEventListener("pointerdown", function (e) {
    if (!open) return;
    if (overPair(open, e.target)) return;
    hide(open);
  });
})();
